class ContentsList extends HTMLElement {
  constructor() {
    super();

    this.articleContentHeadings = document.querySelectorAll('.article-template__content h2');

    this.addIDToHeadings(this.articleContentHeadings);
    this.populateContentsList(this.articleContentHeadings);
  }

  addIDToHeadings(headings) {
    if (headings) {
      headings.forEach(heading => {
        heading.id = `${heading.innerHTML.toLowerCase().replace(/\s+/g, '-')}`;
      });
    }
  }

  populateContentsList(headings) {
    if (headings) {
      const ul = document.createElement('ul');
      headings.forEach(heading => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.textContent = heading.innerHTML;
        a.href = `#${heading.innerHTML.toLowerCase().replace(/\s+/g, '-')}`;
        li.appendChild(a);
        ul.appendChild(li);
      });
      this.appendChild(ul);
    }
  }
}
customElements.define('contents-list', ContentsList);
